<!--
Author: TangChen
Date: 2018-10-25
Desc: 绘制时间控件 默认为证件有效期选中组件，type为1是单个时间选择组件，为2是时间范围选择组件，为3是默认
-->
<template>
    <div class="comp-date-picker comp">
        <el-date-picker
            v-model.trim="beginDate"
            type="date"
            :picker-options="pickerOptions"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="date.text"
            :size="date.size"
            :disabled="date.dis || false"
            v-on:change="backVal"
        />
        <span v-if="date.type=='2'" class="date-text">至</span>
        <el-date-picker
            v-if="date.type=='2'"
            v-model.trim="endDate"
            type="date"
            :picker-options="pickerOptions1"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :placeholder="date.text"
            :disabled="beginDate===''"
            :size="date.size"
            v-on:change="backVal"
        />
        <el-checkbox v-if="date.type=='3'" v-model="checked" :disabled="date.dis || false" class="date-check" v-on:change="dateChange">
            {{ checkedText }}
        </el-checkbox>
    </div>
</template>
<script>
export default {
    name: "DatePicker",
    props: {
        date: {
            type: Object,
            default: function () {
                return {
                    size: "small", // 默认组件大小
                    type: "3"// 默认组件为证件有效期选择组件
                };
            }
        }
    },
    data () {
        return {
            beginDate: "",
            endDate: "",
            maxDate: "",
            minDate: "",
            checkedText: "长期有效",
            checked: false,
            pickerOptions: {
                disabledDate: time => {
                    if (this.date.type === "2") {
                        return (
                            time.getTime() > this.maxDate.getTime() ||
              time.getTime() > new Date(this.endDate).getTime() || time.getTime() < this.minDate.getTime()
                        );
                    } else {
                        return (
                            time.getTime() > this.maxDate.getTime() ||
              time.getTime() < this.minDate.getTime()
                        );
                    }
                }
            },
            pickerOptions1: {
                disabledDate: time => {
                    if (this.date.type === "2" && this.beginDate !== "") {
                        return (
                            time.getTime() > this.maxDate.getTime() ||
              time.getTime() < new Date(this.beginDate).getTime()
                        );
                    }
                }
            }
        };
    },
    watch: {
        date: {
            handler(date) {
                //mod by zhangqc 20200711 修复日期组件不支持清空日期的bug
                if(!(this.date /*&& this.date.val*/)){
                    return;
                }
                if (date.type === "2" && date.val.length === 2) {
                    this.beginDate = date.val[0] || "";
                    this.endDate = date.val[1] || "";
                } else {
                    this.beginDate = date.val || "";
                }
                if (date.type === "3" && date.val === "") {
                    this.checked = false;
                }
            },
            // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
            immediate: true,
            deep: true
        }
    },
    mounted () {
        if (this.date && this.date.val) {
            if (this.date.type === "2" && this.date.val.length === 2) {
                this.beginDate = this.date.val[0];
                this.endDate = this.date.val[1];
            } else {
                this.beginDate = this.date.val;
            }
        }
        if (this.date.val === this.date.max && this.date.val) {
            this.checked = true;
        }
        this.checkedText = this.date.checkedText ? this.date.checkedText : "长期有效";
        this.maxDate =
      this.date.max && this.date.max.indexOf("-") > -1
          ? new Date(this.date.max)
          : new Date();
        this.minDate =
      this.date.min && this.date.min.indexOf("-") > -1
          ? new Date(this.date.min)
          : (this.date.type === "3" ? new Date() : new Date("1950-01-01"));
    },
    methods: {
        backVal (time) {
            if (this.date.type === "2") {
                this.$emit("date-get", {
                    beginDate: this.beginDate,
                    endDate: this.endDate
                });
            } else {
                this.checkedChange();
                this.$emit("date-get", time);
            }
        },
        dateChange () {
            this.beginDate = this.checked ? this.date.max : "";
            this.checkedChange();
            this.$emit("date-get", this.beginDate);
        },
        checkedChange () {
            if (this.date.type === "3") {
                this.checked = this.beginDate === this.date.max;
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.comp-date-picker {
  width: 100%;
  display: inline-block;
  .date-text,
  .date-check {
    padding: 0 10px;
  }
  .el-input.el-input--mini{
    width: 140px;
  }
}
</style>
